
import * as form from "./form";


let dialog_title: string;
let dialog_message: string;
let dialog_buttonTextYes: string;
let dialog_buttonTextNo: string;


/**
* Init dialog screen (will be done after the init for the)
* @param {String} title
* @param {String} message
* @param {String} buttonTextYes
* @param {String} buttonTextNo
*/
export function initialize(title: string, message: string, buttonTextYes: string, buttonTextNo: string): void {
    dialog_title = title;
    dialog_message = message;
    dialog_buttonTextYes = buttonTextYes;
    dialog_buttonTextNo = buttonTextNo;
}

/**
 * Create dialog
 * @param {Function} callbackYes
 * @param {Function} callbackNo
 */
export function createDialog(callbackYes: () => void, callbackNo: () => void): void {
    form.createDialog(dialog_title, dialog_message, dialog_buttonTextYes, callbackYes, dialog_buttonTextNo, callbackNo);
}

/**
 * Create dialog
 * @param {String} title
 * @param {String} message
 * @param {Function} callbackYes
 * @param {Function} callbackNo
 */
export function createDialogWithCustomTitleAndMessage(title: string, message: string, callbackYes: () => void, callbackNo: () => void): void {
    form.createDialog(title, message, dialog_buttonTextYes, callbackYes, dialog_buttonTextNo, callbackNo);
}
export function createWarningDialog(title: string, message: string): void {
    form.createWarningDialog(title, message);
}

export function closeDialog(): void {
    form.closeDialog();
}
